import { Value, Expr, Err, Block, Label } from './ast'
import { Primitives } from './primitives'
import { Stack } from './stack'
import { cellID } from './cell'

const prims = new Primitives();

class Interpreter {
    values: Map<string, Value>;
    code: Expr[][][];
    row: number;
    col: number;

    constructor(code: Expr[][][]) {
        this.values = new Map();
        this.code = code;
    }

    compute(): void {
        this.code.forEach((r, i) => {
            this.row = i;
            const stack = new Stack();
            r.forEach((c, j) => {
                this.col = j;
                const v = this.interpretExprs(c, stack);
                if (v)
                    this.storeCell(i, j, v);
            });
        })
    }

    interpretExprs(exprs: Expr[], stack: Stack): Value {
        try {
            if (exprs.length > 0) {
                exprs.forEach(e => this.interpret(e, stack));
                return stack.peek();
            }
        } catch (error) {
            console.error(error);
            const err: Err = {
                type: "error",
                message: String(error.message)
            }
            stack.pushLiteral(err);
            return err;
        }
    }

    interpret(expr: Expr, stack: Stack): void {
        switch (expr.type) {
            case "word":
                if (prims.word(expr.name, stack, this))
                    return;

                const value = this.lookup(expr.name);
                switch (value.type) {
                    case "block":
                        value.code.forEach(x => {
                            this.interpret(x, stack)
                        })
                        break;
                    default:
                        stack.items.push(value);
                }
                break;
            case "operator":
                return prims.operator(expr.name, stack, this);
            case "error":
                throw new Error(expr.message)
            default:
                stack.pushLiteral(expr);
                break;
        }
    }

    lookup(name: string): Value {
        const key = name.toLowerCase();
        if (this.values.has(key)) {
            const value = this.values.get(key);
            if (value.type == "error")
                throw new Error("error at " + name)
            if (value.type == "label")
                return value.value;

            return value;
        }

        throw new Error("invalid reference: " + name)
    }


    lookupCell(row: number, col: number): Value {
        return this.lookup(cellID(row, col));
    }

    storeCell(row: number, col: number, value: Value): void {
        this.store(cellID(row, col), value);
    }

    store(name: string, value: Value): void {
        this.values.set(name.toLowerCase(), value)
    }
}

export { Interpreter }